var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { of, timer } from "rxjs";
import { mergeMap } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AppService = /** @class */ (function () {
    function AppService(http) {
        this.http = http;
        this.copyJob = null;
        // Holds a pre-opened popup created via a direct user gesture
        this.jboxPopupRef = null;
        // const a = this.getJobStatus().subscribe((r) => console.log(r));
        // timer(30000).toPromise().then(() => a.unsubscribe())
    }
    AppService.prototype.setCookie = function (cname, cvalue, exdays, domain) {
        if (domain === void 0) { domain = ".tutored.me"; }
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie =
            cname + "=" + cvalue + ";" + expires + ";domain=" + domain + ";path=/";
    };
    AppService.prototype.deleteCookie = function (name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    };
    AppService.prototype.getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2)
            return parts.pop().split(";").shift();
    };
    // send message
    AppService.prototype.putSendMessage = function (body) {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/contact-user/send-email";
        return this.http.put(url, body);
    };
    // get suggested targets
    AppService.prototype.getSuggestedTargets = function (moked) {
        if (moked === void 0) { moked = false; }
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/targets/suggested-targets";
        if (!moked) {
            return this.http.get(url);
        }
        else {
            return of([
                /*
                {
                  title: "STEM",
                  id: 406953,
                  countries_id: null,
                  countries_ids: [1],
                  cities_ids: [],
                  industries_ids: [],
                  sectors_ids: [],
                  institutes_ids: [],
                  faculty_tags: [],
                  macro_study_tags_ids: [],
                  study_tags_ids: [
                    12, 30, 36, 40, 46, 62, 70, 76, 82, 84, 90, 118, 140, 142, 162, 271,
                    279,
                  ],
                  course_tags: [
                    "physics_engineering",
                    "math",
                    "electronics_engineering",
                    "computer",
                    "statistic",
                    "aerospace_engineering",
                    "chemistry",
                    "physics",
                    "information_engineering",
                    "telecommunication_engineering",
                    "automation_engineering",
                    "biomedical_engineering",
                    "math_engineering",
                    "electrical_engineering",
                    "computer_engineering",
                    "electricaltech_engineering",
                    "cybersecurity",
                  ],
                  locations_ids: [],
                  use_profile_locations_id: null,
                  use_profile_institutes_id: false,
                  use_profile_cities_id: false,
                  use_profile_countries_id: false,
                  use_profile_study_tag: false,
                  use_profile_macro_study_tag: false,
                  tags: "",
                  cities_id: null,
                  universities_id: null,
                  faculty_tag: null,
                  course_tag: null,
                  is_internal: false,
                  filter_definitions_id: 13162,
                  countries: [
                    {
                      id: 1,
                      name: "Italia",
                      view: true,
                      tag: "it",
                      created_at: "2015-08-03T13:23:13.000Z",
                      updated_at: "2018-11-07T14:36:42.000Z",
                    },
                  ],
                  cities: [],
                  study_tags: [
                    {
                      id: 12,
                      tag: "physics_engineering",
                      name_it: "Ingegneria Fisica",
                      name_en: "Physical Engineering",
                      name_es: "Ingeniería Física",
                      name_fr: "Génie physique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 30,
                      tag: "math",
                      name_it: "Matematica",
                      name_en: "Mathematics",
                      name_es: "Matemática",
                      name_fr: "Mathématiques",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 36,
                      tag: "electronics_engineering",
                      name_it: "Ingegneria Elettronica",
                      name_en: "Electronic Engineering",
                      name_es: "Ingeniería Electrónica",
                      name_fr: "Génie électronique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 40,
                      tag: "computer",
                      name_it: "Informatica",
                      name_en: "Computer Science",
                      name_es: "Informática",
                      name_fr: "Informatique",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 46,
                      tag: "statistic",
                      name_it: "Statistica",
                      name_en: "Statistics",
                      name_es: "Estadística",
                      name_fr: "Statistiques ",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 62,
                      tag: "aerospace_engineering",
                      name_it: "Ingegneria Aerospaziale",
                      name_en: "Aerospace Engineering",
                      name_es: "Ingeniería Aeroespacial",
                      name_fr: "Génie aérospatial",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 70,
                      tag: "chemistry",
                      name_it: "Chimica",
                      name_en: "Chemistry",
                      name_es: "Química",
                      name_fr: "Chimie",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 76,
                      tag: "physics",
                      name_it: "Fisica",
                      name_en: "Physics",
                      name_es: "Física",
                      name_fr: "Physique",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 82,
                      tag: "information_engineering",
                      name_it: "Ingegneria dell’Informazione",
                      name_en: "Information Engineering",
                      name_es: "Ingeniería de Sistemas de Información",
                      name_fr: "Génie des technologies de l'information",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 84,
                      tag: "telecommunication_engineering",
                      name_it: "Ingegneria delle Telecomunicazioni",
                      name_en: "Telecommunications Engineering",
                      name_es: "Ingeniería de Telecomunicación ",
                      name_fr: "Génie des télécommunications",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 90,
                      tag: "automation_engineering",
                      name_it: "Ingegneria dell’Automazione",
                      name_en: "Automation Engineering",
                      name_es: "Ingenieria de Automatizacion",
                      name_fr:
                        "Génie mécanique et Automatisation des Systèmes Industriels",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 118,
                      tag: "biomedical_engineering",
                      name_it: "Ingegneria Biomedica",
                      name_en: "Biomedical Engineering",
                      name_es: "Ingeniería Biomédica",
                      name_fr: "Génie biomédical",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 140,
                      tag: "math_engineering",
                      name_it: "Ingegneria Matematica",
                      name_en: "Mathematical Engineering",
                      name_es: "Ingeniería Matemática",
                      name_fr: "Génie mathématique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 142,
                      tag: "electrical_engineering",
                      name_it: "Ingegneria Elettrica",
                      name_en: "Electrical Engineering",
                      name_es: "Ingeniería Eléctrica",
                      name_fr: "Génie électrique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 162,
                      tag: "computer_engineering",
                      name_it: "Ingegneria Informatica",
                      name_en: "Computer Engineering",
                      name_es: "Ingeniería Informática",
                      name_fr: "Génie informatique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 271,
                      tag: "electricaltech_engineering",
                      name_it: "Ingegneria Elettrotecnica",
                      name_en: "Electrical Engineering",
                      name_es: "Ingeniería Electromecánica",
                      name_fr: "Génie électrotechnique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 279,
                      tag: "cybersecurity",
                      name_it: "Cybersecurity",
                      name_en: "Cybersecurity",
                      name_es: "Cybersecurity",
                      name_fr: "Cybersecurity",
                      macro_study_tags_id: 0,
                      created_at: "2021-03-30T10:08:27.000Z",
                      updated_at: "2021-03-30T10:08:27.000Z",
                    },
                  ],
                  macro_study_tags: [],
                  institutes: [],
                },
                {
                  title: "STEM+E",
                  id: 406954,
                  countries_id: null,
                  countries_ids: [1],
                  cities_ids: [],
                  industries_ids: [],
                  sectors_ids: [],
                  institutes_ids: [],
                  faculty_tags: [],
                  macro_study_tags_ids: [],
                  study_tags_ids: [
                    62, 90, 118, 70, 162, 271, 36, 82, 140, 30, 12, 76, 84, 46, 40, 279,
                    48, 265, 132, 261, 264, 263, 6, 2, 257, 86, 38,
                  ],
                  course_tags: [
                    "aerospace_engineering",
                    "automation_engineering",
                    "biomedical_engineering",
                    "chemistry",
                    "computer_engineering",
                    "electricaltech_engineering",
                    "electronics_engineering",
                    "information_engineering",
                    "math_engineering",
                    "math",
                    "physics_engineering",
                    "physics",
                    "telecommunication_engineering",
                    "statistic",
                    "computer",
                    "cybersecurity",
                    "accounting_economics",
                    "business_economics",
                    "consulting_economics",
                    "economics_international",
                    "economics_science",
                    "environment_economics",
                    "law_economics",
                    "management_economics",
                    "tourism_economics",
                    "management_engineering",
                    "finance",
                  ],
                  locations_ids: [],
                  use_profile_locations_id: null,
                  use_profile_institutes_id: false,
                  use_profile_cities_id: false,
                  use_profile_countries_id: false,
                  use_profile_study_tag: false,
                  use_profile_macro_study_tag: false,
                  tags: "",
                  cities_id: null,
                  universities_id: null,
                  faculty_tag: null,
                  course_tag: null,
                  is_internal: false,
                  filter_definitions_id: 13162,
                  countries: [
                    {
                      id: 1,
                      name: "Italia",
                      view: true,
                      tag: "it",
                      created_at: "2015-08-03T13:23:13.000Z",
                      updated_at: "2018-11-07T14:36:42.000Z",
                    },
                  ],
                  cities: [],
                  study_tags: [
                    {
                      id: 2,
                      tag: "management_economics",
                      name_it: "Economia e Management",
                      name_en: "Managerial Economics",
                      name_es: "Administración y Dirección de Empresas",
                      name_fr: "Economie et Gestion",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 6,
                      tag: "law_economics",
                      name_it: "Economia e Diritto",
                      name_en: "Economics and Law",
                      name_es: "ADE y Derecho",
                      name_fr: "Economie et Droit",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 12,
                      tag: "physics_engineering",
                      name_it: "Ingegneria Fisica",
                      name_en: "Physical Engineering",
                      name_es: "Ingeniería Física",
                      name_fr: "Génie physique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 30,
                      tag: "math",
                      name_it: "Matematica",
                      name_en: "Mathematics",
                      name_es: "Matemática",
                      name_fr: "Mathématiques",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 36,
                      tag: "electronics_engineering",
                      name_it: "Ingegneria Elettronica",
                      name_en: "Electronic Engineering",
                      name_es: "Ingeniería Electrónica",
                      name_fr: "Génie électronique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 38,
                      tag: "finance",
                      name_it: "Finanza",
                      name_en: "Finance",
                      name_es: "Finanzas",
                      name_fr: "Finance",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 40,
                      tag: "computer",
                      name_it: "Informatica",
                      name_en: "Computer Science",
                      name_es: "Informática",
                      name_fr: "Informatique",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 46,
                      tag: "statistic",
                      name_it: "Statistica",
                      name_en: "Statistics",
                      name_es: "Estadística",
                      name_fr: "Statistiques ",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 48,
                      tag: "accounting_economics",
                      name_it: "Economia e Commercio",
                      name_en: "Accounting",
                      name_es: "Economía y Negocios Internacionales",
                      name_fr: "Gestion et Comptabilité",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 62,
                      tag: "aerospace_engineering",
                      name_it: "Ingegneria Aerospaziale",
                      name_en: "Aerospace Engineering",
                      name_es: "Ingeniería Aeroespacial",
                      name_fr: "Génie aérospatial",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 70,
                      tag: "chemistry",
                      name_it: "Chimica",
                      name_en: "Chemistry",
                      name_es: "Química",
                      name_fr: "Chimie",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 76,
                      tag: "physics",
                      name_it: "Fisica",
                      name_en: "Physics",
                      name_es: "Física",
                      name_fr: "Physique",
                      macro_study_tags_id: 2,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 82,
                      tag: "information_engineering",
                      name_it: "Ingegneria dell’Informazione",
                      name_en: "Information Engineering",
                      name_es: "Ingeniería de Sistemas de Información",
                      name_fr: "Génie des technologies de l'information",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 84,
                      tag: "telecommunication_engineering",
                      name_it: "Ingegneria delle Telecomunicazioni",
                      name_en: "Telecommunications Engineering",
                      name_es: "Ingeniería de Telecomunicación ",
                      name_fr: "Génie des télécommunications",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 86,
                      tag: "management_engineering",
                      name_it: "Ingegneria Gestionale",
                      name_en: "Management Engineering",
                      name_es: "Ingeniería en Organización Industrial",
                      name_fr: "Génie économique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 90,
                      tag: "automation_engineering",
                      name_it: "Ingegneria dell’Automazione",
                      name_en: "Automation Engineering",
                      name_es: "Ingenieria de Automatizacion",
                      name_fr:
                        "Génie mécanique et Automatisation des Systèmes Industriels",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 118,
                      tag: "biomedical_engineering",
                      name_it: "Ingegneria Biomedica",
                      name_en: "Biomedical Engineering",
                      name_es: "Ingeniería Biomédica",
                      name_fr: "Génie biomédical",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 132,
                      tag: "consulting_economics",
                      name_it: "Economia e Consulenza",
                      name_en: "Consultancy",
                      name_es: "Economía y Consultoría",
                      name_fr: "Economie et Conseil",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 140,
                      tag: "math_engineering",
                      name_it: "Ingegneria Matematica",
                      name_en: "Mathematical Engineering",
                      name_es: "Ingeniería Matemática",
                      name_fr: "Génie mathématique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 162,
                      tag: "computer_engineering",
                      name_it: "Ingegneria Informatica",
                      name_en: "Computer Engineering",
                      name_es: "Ingeniería Informática",
                      name_fr: "Génie informatique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 257,
                      tag: "tourism_economics",
                      name_it: "Economia e Turismo",
                      name_en: "Tourism Economics",
                      name_es: "Gestión Turística y Hotelera",
                      name_fr: "Economie et Tourisme",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 261,
                      tag: "economics_international",
                      name_it: "Economia Internazionale",
                      name_en: "International Economics",
                      name_es: "Negocios Internacionales",
                      name_fr: "Economie Internationale",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 263,
                      tag: "environment_economics",
                      name_it: "Economia Ambientale",
                      name_en: "Environmental Economics",
                      name_es: "Economía y Medio ambiente",
                      name_fr: "Economie - Géographie",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 264,
                      tag: "economics_science",
                      name_it: "Scienze Economiche",
                      name_en: "Economic Sciences",
                      name_es: "Ciencias económicas ",
                      name_fr: "Sciences économiques",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 265,
                      tag: "business_economics",
                      name_it: "Business Administration",
                      name_en: "Business Administration",
                      name_es: "Business Administration",
                      name_fr: "Administration Economique et Sociale",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 271,
                      tag: "electricaltech_engineering",
                      name_it: "Ingegneria Elettrotecnica",
                      name_en: "Electrical Engineering",
                      name_es: "Ingeniería Electromecánica",
                      name_fr: "Génie électrotechnique",
                      macro_study_tags_id: 1,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 279,
                      tag: "cybersecurity",
                      name_it: "Cybersecurity",
                      name_en: "Cybersecurity",
                      name_es: "Cybersecurity",
                      name_fr: "Cybersecurity",
                      macro_study_tags_id: 0,
                      created_at: "2021-03-30T10:08:27.000Z",
                      updated_at: "2021-03-30T10:08:27.000Z",
                    },
                  ],
                  macro_study_tags: [],
                  institutes: [],
                },
                {
                  title: "ECONOMICS",
                  id: 406949,
                  countries_id: null,
                  countries_ids: [1],
                  cities_ids: [],
                  industries_ids: [],
                  sectors_ids: [],
                  institutes_ids: [],
                  faculty_tags: ["economics", "marketing"],
                  macro_study_tags_ids: [3, 11],
                  study_tags_ids: [2, 6, 38, 48, 132, 257, 261, 263, 264, 265],
                  course_tags: [
                    "management_economics",
                    "law_economics",
                    "finance",
                    "accounting_economics",
                    "consulting_economics",
                    "tourism_economics",
                    "economics_international",
                    "environment_economics",
                    "economics_science",
                    "business_economics",
                  ],
                  locations_ids: [],
                  use_profile_locations_id: null,
                  use_profile_institutes_id: false,
                  use_profile_cities_id: false,
                  use_profile_countries_id: false,
                  use_profile_study_tag: false,
                  use_profile_macro_study_tag: false,
                  tags: "",
                  cities_id: null,
                  universities_id: null,
                  faculty_tag: null,
                  course_tag: null,
                  is_internal: false,
                  filter_definitions_id: 13162,
                  countries: [
                    {
                      id: 1,
                      name: "Italia",
                      view: true,
                      tag: "it",
                      created_at: "2015-08-03T13:23:13.000Z",
                      updated_at: "2018-11-07T14:36:42.000Z",
                    },
                  ],
                  cities: [],
                  study_tags: [
                    {
                      id: 2,
                      tag: "management_economics",
                      name_it: "Economia e Management",
                      name_en: "Managerial Economics",
                      name_es: "Administración y Dirección de Empresas",
                      name_fr: "Economie et Gestion",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 6,
                      tag: "law_economics",
                      name_it: "Economia e Diritto",
                      name_en: "Economics and Law",
                      name_es: "ADE y Derecho",
                      name_fr: "Economie et Droit",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 38,
                      tag: "finance",
                      name_it: "Finanza",
                      name_en: "Finance",
                      name_es: "Finanzas",
                      name_fr: "Finance",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 48,
                      tag: "accounting_economics",
                      name_it: "Economia e Commercio",
                      name_en: "Accounting",
                      name_es: "Economía y Negocios Internacionales",
                      name_fr: "Gestion et Comptabilité",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 132,
                      tag: "consulting_economics",
                      name_it: "Economia e Consulenza",
                      name_en: "Consultancy",
                      name_es: "Economía y Consultoría",
                      name_fr: "Economie et Conseil",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 257,
                      tag: "tourism_economics",
                      name_it: "Economia e Turismo",
                      name_en: "Tourism Economics",
                      name_es: "Gestión Turística y Hotelera",
                      name_fr: "Economie et Tourisme",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 261,
                      tag: "economics_international",
                      name_it: "Economia Internazionale",
                      name_en: "International Economics",
                      name_es: "Negocios Internacionales",
                      name_fr: "Economie Internationale",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 263,
                      tag: "environment_economics",
                      name_it: "Economia Ambientale",
                      name_en: "Environmental Economics",
                      name_es: "Economía y Medio ambiente",
                      name_fr: "Economie - Géographie",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 264,
                      tag: "economics_science",
                      name_it: "Scienze Economiche",
                      name_en: "Economic Sciences",
                      name_es: "Ciencias económicas ",
                      name_fr: "Sciences économiques",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 265,
                      tag: "business_economics",
                      name_it: "Business Administration",
                      name_en: "Business Administration",
                      name_es: "Business Administration",
                      name_fr: "Administration Economique et Sociale",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                  ],
                  macro_study_tags: [
                    {
                      id: 3,
                      tag: "economics",
                      name_it: "Economia",
                      name_fr: "Economie",
                      name_en: "Economics",
                      name_es: "Ciencias económicas",
                      created_at: "2020-04-29T11:11:29.000Z",
                      updated_at: "2020-04-29T11:11:29.000Z",
                    },
                    {
                      id: 11,
                      tag: "marketing",
                      name_it: "Marketing",
                      name_fr: "Marketing",
                      name_en: "Marketing",
                      name_es: "Marketing",
                      created_at: "2021-03-11T14:43:49.000Z",
                      updated_at: "2021-03-11T14:43:49.000Z",
                    },
                  ],
                  institutes: [],
                },
                {
                  title: "LAW",
                  id: 406950,
                  countries_id: null,
                  countries_ids: [1],
                  cities_ids: [],
                  industries_ids: [],
                  sectors_ids: [],
                  institutes_ids: [],
                  faculty_tags: ["law"],
                  macro_study_tags_ids: [8],
                  study_tags_ids: [6, 275],
                  course_tags: ["law_economics", "law"],
                  locations_ids: [],
                  use_profile_locations_id: null,
                  use_profile_institutes_id: false,
                  use_profile_cities_id: false,
                  use_profile_countries_id: false,
                  use_profile_study_tag: false,
                  use_profile_macro_study_tag: false,
                  tags: "",
                  cities_id: null,
                  universities_id: null,
                  faculty_tag: null,
                  course_tag: null,
                  is_internal: false,
                  filter_definitions_id: 13162,
                  countries: [
                    {
                      id: 1,
                      name: "Italia",
                      view: true,
                      tag: "it",
                      created_at: "2015-08-03T13:23:13.000Z",
                      updated_at: "2018-11-07T14:36:42.000Z",
                    },
                  ],
                  cities: [],
                  study_tags: [
                    {
                      id: 6,
                      tag: "law_economics",
                      name_it: "Economia e Diritto",
                      name_en: "Economics and Law",
                      name_es: "ADE y Derecho",
                      name_fr: "Economie et Droit",
                      macro_study_tags_id: 3,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 275,
                      tag: "law",
                      name_it: "Giurisprudenza",
                      name_en: "Law",
                      name_es: "Derecho",
                      name_fr: "Droit",
                      macro_study_tags_id: 8,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                  ],
                  macro_study_tags: [
                    {
                      id: 8,
                      tag: "law",
                      name_it: "Giurisprudenza",
                      name_fr: "Droit",
                      name_en: "Law",
                      name_es: "Derecho",
                      created_at: "2020-04-29T11:11:30.000Z",
                      updated_at: "2020-04-29T11:11:30.000Z",
                    },
                  ],
                  institutes: [],
                },
                {
                  title: "HUMANITIES",
                  id: 406951,
                  countries_id: null,
                  countries_ids: [1],
                  cities_ids: [],
                  industries_ids: [],
                  sectors_ids: [],
                  institutes_ids: [],
                  faculty_tags: ["literature"],
                  macro_study_tags_ids: [4],
                  study_tags_ids: [18, 60, 106, 108, 116, 128, 258, 259],
                  course_tags: [
                    "language",
                    "art",
                    "archeology",
                    "history",
                    "sociology",
                    "journalism",
                    "translation",
                    "education",
                  ],
                  locations_ids: [],
                  use_profile_locations_id: null,
                  use_profile_institutes_id: false,
                  use_profile_cities_id: false,
                  use_profile_countries_id: false,
                  use_profile_study_tag: false,
                  use_profile_macro_study_tag: false,
                  tags: "",
                  cities_id: null,
                  universities_id: null,
                  faculty_tag: null,
                  course_tag: null,
                  is_internal: false,
                  filter_definitions_id: 13162,
                  countries: [
                    {
                      id: 1,
                      name: "Italia",
                      view: true,
                      tag: "it",
                      created_at: "2015-08-03T13:23:13.000Z",
                      updated_at: "2018-11-07T14:36:42.000Z",
                    },
                  ],
                  cities: [],
                  study_tags: [
                    {
                      id: 18,
                      tag: "language",
                      name_it: "Lingue",
                      name_en: "Languages",
                      name_es: "Lenguas modernas",
                      name_fr: "Lanuges étrangères ",
                      macro_study_tags_id: 4,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 60,
                      tag: "art",
                      name_it: "Arte",
                      name_en: "Art",
                      name_es: "Bellas artes",
                      name_fr: "Art",
                      macro_study_tags_id: 4,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 106,
                      tag: "archeology",
                      name_it: "Archeologia",
                      name_en: "Archeology",
                      name_es: "Arqueología",
                      name_fr: "Archéologie",
                      macro_study_tags_id: 4,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 108,
                      tag: "history",
                      name_it: "Storia",
                      name_en: "History",
                      name_es: "Historia",
                      name_fr: "Histoire",
                      macro_study_tags_id: 4,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 116,
                      tag: "sociology",
                      name_it: "Sociologia",
                      name_en: "Social Sciences",
                      name_es: "Sociología",
                      name_fr: "Sciences Sociales",
                      macro_study_tags_id: 7,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 128,
                      tag: "journalism",
                      name_it: "Giornalismo",
                      name_en: "Journalism",
                      name_es: "Periodismo",
                      name_fr: "Information et Communication",
                      macro_study_tags_id: 4,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 258,
                      tag: "translation",
                      name_it: "Traduzione e Interpretariato",
                      name_en: "Translation & Interpretation",
                      name_es: "Traducción e interpretación ",
                      name_fr: "Traduction et interprétation",
                      macro_study_tags_id: 4,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                    {
                      id: 259,
                      tag: "education",
                      name_it: "Educazione e formazione",
                      name_en: "Education and Training",
                      name_es: "Educación y Formación ",
                      name_fr: "Sciences de l'éducation",
                      macro_study_tags_id: 6,
                      created_at: "2020-05-11T05:54:29.000Z",
                      updated_at: "2020-05-11T05:54:29.000Z",
                    },
                  ],
                  macro_study_tags: [
                    {
                      id: 4,
                      tag: "literature",
                      name_it: "Lettere",
                      name_fr: "Lettres",
                      name_en: "Literature",
                      name_es: "Literatura",
                      created_at: "2020-04-29T11:11:29.000Z",
                      updated_at: "2020-04-29T11:11:29.000Z",
                    },
                  ],
                  institutes: [],
                },
                */
                // NEW
                {
                    title: "Coding",
                    id: 482544,
                    countries_id: null,
                    countries_ids: [],
                    cities_ids: [],
                    industries_ids: [],
                    sectors_ids: [],
                    institutes_ids: [],
                    faculty_tags: [],
                    macro_study_tags_ids: [],
                    study_tags_ids: [
                        279, 62, 118, 90, 82, 162, 40, 84, 36, 271, 30, 140, 76, 12, 46,
                        280,
                    ],
                    course_tags: [
                        "cybersecurity",
                        "aerospace_engineering",
                        "biomedical_engineering",
                        "automation_engineering",
                        "information_engineering",
                        "computer_engineering",
                        "computer",
                        "telecommunication_engineering",
                        "electronics_engineering",
                        "electricaltech_engineering",
                        "math",
                        "math_engineering",
                        "physics",
                        "physics_engineering",
                        "statistic",
                        "artificial_intelligence",
                    ],
                    locations_ids: [],
                    use_profile_locations_id: null,
                    use_profile_institutes_id: false,
                    use_profile_cities_id: false,
                    use_profile_countries_id: false,
                    use_profile_study_tag: false,
                    use_profile_macro_study_tag: false,
                    tags: "",
                    cities_id: null,
                    universities_id: null,
                    faculty_tag: null,
                    course_tag: null,
                    is_internal: false,
                    filter_definitions_id: 21248,
                    countries: [],
                    cities: [],
                    study_tags: [
                        {
                            id: 12,
                            tag: "physics_engineering",
                            name_it: "Ingegneria Fisica",
                            name_en: "Physical Engineering",
                            name_es: "Ingeniería Física",
                            name_fr: "Génie physique",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 30,
                            tag: "math",
                            name_it: "Matematica",
                            name_en: "Mathematics",
                            name_es: "Matemática",
                            name_fr: "Mathématiques",
                            macro_study_tags_id: 2,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 36,
                            tag: "electronics_engineering",
                            name_it: "Ingegneria Elettronica",
                            name_en: "Electronic Engineering",
                            name_es: "Ingeniería Electrónica",
                            name_fr: "Génie électronique",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 40,
                            tag: "computer",
                            name_it: "Informatica",
                            name_en: "Computer Science",
                            name_es: "Informática",
                            name_fr: "Informatique",
                            macro_study_tags_id: 2,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 46,
                            tag: "statistic",
                            name_it: "Statistica",
                            name_en: "Statistics",
                            name_es: "Estadística",
                            name_fr: "Statistiques ",
                            macro_study_tags_id: 2,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 62,
                            tag: "aerospace_engineering",
                            name_it: "Ingegneria Aerospaziale",
                            name_en: "Aerospace Engineering",
                            name_es: "Ingeniería Aeroespacial",
                            name_fr: "Génie aérospatial",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 76,
                            tag: "physics",
                            name_it: "Fisica",
                            name_en: "Physics",
                            name_es: "Física",
                            name_fr: "Physique",
                            macro_study_tags_id: 2,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 82,
                            tag: "information_engineering",
                            name_it: "Ingegneria dell’Informazione",
                            name_en: "Information Engineering",
                            name_es: "Ingeniería de Sistemas de Información",
                            name_fr: "Génie des technologies de l'information",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 84,
                            tag: "telecommunication_engineering",
                            name_it: "Ingegneria delle Telecomunicazioni",
                            name_en: "Telecommunications Engineering",
                            name_es: "Ingeniería de Telecomunicación ",
                            name_fr: "Génie des télécommunications",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 90,
                            tag: "automation_engineering",
                            name_it: "Ingegneria dell’Automazione",
                            name_en: "Automation Engineering",
                            name_es: "Ingenieria de Automatizacion",
                            name_fr: "Génie mécanique et Automatisation des Systèmes Industriels",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 118,
                            tag: "biomedical_engineering",
                            name_it: "Ingegneria Biomedica",
                            name_en: "Biomedical Engineering",
                            name_es: "Ingeniería Biomédica",
                            name_fr: "Génie biomédical",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 140,
                            tag: "math_engineering",
                            name_it: "Ingegneria Matematica",
                            name_en: "Mathematical Engineering",
                            name_es: "Ingeniería Matemática",
                            name_fr: "Génie mathématique",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 162,
                            tag: "computer_engineering",
                            name_it: "Ingegneria Informatica",
                            name_en: "Computer Engineering",
                            name_es: "Ingeniería Informática",
                            name_fr: "Génie informatique",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 271,
                            tag: "electricaltech_engineering",
                            name_it: "Ingegneria Elettrotecnica",
                            name_en: "Electrotechnical Engineering",
                            name_es: "Ingeniería Electromecánica",
                            name_fr: "Génie électrotechnique",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 279,
                            tag: "cybersecurity",
                            name_it: "Cybersecurity",
                            name_en: "Cybersecurity",
                            name_es: "Cybersecurity",
                            name_fr: "Cybersecurity",
                            macro_study_tags_id: 1,
                            created_at: "2021-03-30T10:08:27.000Z",
                            updated_at: "2021-03-30T10:08:27.000Z",
                        },
                        {
                            id: 280,
                            tag: "artificial_intelligence",
                            name_it: "Intelligenza Artificiale",
                            name_en: "Artificial Intelligence",
                            name_es: "Intelligencia Artificial",
                            name_fr: "Intelligence Artificielle",
                            macro_study_tags_id: 2,
                            created_at: "2021-11-10T14:21:40.000Z",
                            updated_at: "2021-11-10T14:21:40.000Z",
                        },
                    ],
                    macro_study_tags: [],
                    institutes: [],
                },
                {
                    title: "Business & Management Engineering",
                    id: 482552,
                    countries_id: null,
                    countries_ids: [],
                    cities_ids: [],
                    industries_ids: [],
                    sectors_ids: [],
                    institutes_ids: [],
                    faculty_tags: [],
                    macro_study_tags_ids: [],
                    study_tags_ids: [86, 6, 263, 261, 2, 257, 265],
                    course_tags: [
                        "management_engineering",
                        "law_economics",
                        "environment_economics",
                        "economics_international",
                        "management_economics",
                        "tourism_economics",
                        "business_economics",
                    ],
                    locations_ids: [],
                    use_profile_locations_id: null,
                    use_profile_institutes_id: false,
                    use_profile_cities_id: false,
                    use_profile_countries_id: false,
                    use_profile_study_tag: false,
                    use_profile_macro_study_tag: false,
                    tags: "",
                    cities_id: null,
                    universities_id: null,
                    faculty_tag: null,
                    course_tag: null,
                    is_internal: false,
                    filter_definitions_id: 21251,
                    countries: [],
                    cities: [],
                    study_tags: [
                        {
                            id: 2,
                            tag: "management_economics",
                            name_it: "Economia e Management",
                            name_en: "Managerial Economics",
                            name_es: "Administración y Dirección de Empresas",
                            name_fr: "Economie et Gestion",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 6,
                            tag: "law_economics",
                            name_it: "Economia e Diritto",
                            name_en: "Economics and Law",
                            name_es: "ADE y Derecho",
                            name_fr: "Economie et Droit",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 86,
                            tag: "management_engineering",
                            name_it: "Ingegneria Gestionale",
                            name_en: "Management Engineering",
                            name_es: "Ingeniería en Organización Industrial",
                            name_fr: "Génie économique",
                            macro_study_tags_id: 1,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 257,
                            tag: "tourism_economics",
                            name_it: "Economia e Turismo",
                            name_en: "Tourism Economics",
                            name_es: "Gestión Turística y Hotelera",
                            name_fr: "Economie et Tourisme",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 261,
                            tag: "economics_international",
                            name_it: "Economia Internazionale",
                            name_en: "International Economics",
                            name_es: "Negocios Internacionales",
                            name_fr: "Economie Internationale",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 263,
                            tag: "environment_economics",
                            name_it: "Economia Ambientale",
                            name_en: "Environmental Economics",
                            name_es: "Economía y Medio ambiente",
                            name_fr: "Economie - Géographie",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 265,
                            tag: "business_economics",
                            name_it: "Business Administration",
                            name_en: "Business Administration",
                            name_es: "Business Administration",
                            name_fr: "Administration Economique et Sociale",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                    ],
                    macro_study_tags: [],
                    institutes: [],
                },
                {
                    title: "STEM",
                    id: 482547,
                    countries_id: null,
                    countries_ids: [],
                    cities_ids: [],
                    industries_ids: [],
                    sectors_ids: [],
                    institutes_ids: [],
                    faculty_tags: ["engineering", "science"],
                    macro_study_tags_ids: [1, 2],
                    study_tags_ids: [],
                    course_tags: [],
                    locations_ids: [],
                    use_profile_locations_id: null,
                    use_profile_institutes_id: false,
                    use_profile_cities_id: false,
                    use_profile_countries_id: false,
                    use_profile_study_tag: false,
                    use_profile_macro_study_tag: false,
                    tags: "",
                    cities_id: null,
                    universities_id: null,
                    faculty_tag: null,
                    course_tag: null,
                    is_internal: false,
                    filter_definitions_id: 21250,
                    countries: [],
                    cities: [],
                    study_tags: [],
                    macro_study_tags: [
                        {
                            id: 1,
                            tag: "engineering",
                            name_it: "Ingegneria",
                            name_fr: "Génie",
                            name_en: "Engineering",
                            name_es: "Ingeniería",
                            created_at: "2020-04-29T11:11:29.000Z",
                            updated_at: "2020-04-29T11:11:29.000Z",
                        },
                        {
                            id: 2,
                            tag: "science",
                            name_it: "Scienze",
                            name_fr: "Sciences",
                            name_en: "Science",
                            name_es: "Sciences",
                            created_at: "2020-04-29T11:11:29.000Z",
                            updated_at: "2020-04-29T11:11:29.000Z",
                        },
                    ],
                    institutes: [],
                },
                {
                    title: "Business & Marketing",
                    id: 482551,
                    countries_id: null,
                    countries_ids: [],
                    cities_ids: [],
                    industries_ids: [],
                    sectors_ids: [],
                    institutes_ids: [],
                    faculty_tags: [],
                    macro_study_tags_ids: [],
                    study_tags_ids: [264, 263, 261, 2, 257, 4, 265],
                    course_tags: [
                        "economics_science",
                        "environment_economics",
                        "economics_international",
                        "management_economics",
                        "tourism_economics",
                        "marketing",
                        "business_economics",
                    ],
                    locations_ids: [],
                    use_profile_locations_id: null,
                    use_profile_institutes_id: false,
                    use_profile_cities_id: false,
                    use_profile_countries_id: false,
                    use_profile_study_tag: false,
                    use_profile_macro_study_tag: false,
                    tags: "",
                    cities_id: null,
                    universities_id: null,
                    faculty_tag: null,
                    course_tag: null,
                    is_internal: false,
                    filter_definitions_id: 21252,
                    countries: [],
                    cities: [],
                    study_tags: [
                        {
                            id: 2,
                            tag: "management_economics",
                            name_it: "Economia e Management",
                            name_en: "Managerial Economics",
                            name_es: "Administración y Dirección de Empresas",
                            name_fr: "Economie et Gestion",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 4,
                            tag: "marketing",
                            name_it: "Comunicazione & Marketing",
                            name_en: "Communication & Marketing",
                            name_es: "Marketing y Comunicación",
                            name_fr: "Marketing et communication",
                            macro_study_tags_id: 11,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 257,
                            tag: "tourism_economics",
                            name_it: "Economia e Turismo",
                            name_en: "Tourism Economics",
                            name_es: "Gestión Turística y Hotelera",
                            name_fr: "Economie et Tourisme",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 261,
                            tag: "economics_international",
                            name_it: "Economia Internazionale",
                            name_en: "International Economics",
                            name_es: "Negocios Internacionales",
                            name_fr: "Economie Internationale",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 263,
                            tag: "environment_economics",
                            name_it: "Economia Ambientale",
                            name_en: "Environmental Economics",
                            name_es: "Economía y Medio ambiente",
                            name_fr: "Economie - Géographie",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 264,
                            tag: "economics_science",
                            name_it: "Scienze Economiche",
                            name_en: "Economic Sciences",
                            name_es: "Ciencias económicas ",
                            name_fr: "Sciences économiques",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 265,
                            tag: "business_economics",
                            name_it: "Business Administration",
                            name_en: "Business Administration",
                            name_es: "Business Administration",
                            name_fr: "Administration Economique et Sociale",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                    ],
                    macro_study_tags: [],
                    institutes: [],
                },
                {
                    title: "Architecture & Design",
                    id: 482562,
                    countries_id: null,
                    countries_ids: [],
                    cities_ids: [],
                    industries_ids: [],
                    sectors_ids: [],
                    institutes_ids: [],
                    faculty_tags: ["architecture"],
                    macro_study_tags_ids: [9],
                    study_tags_ids: [56],
                    course_tags: ["design"],
                    locations_ids: [],
                    use_profile_locations_id: null,
                    use_profile_institutes_id: false,
                    use_profile_cities_id: false,
                    use_profile_countries_id: false,
                    use_profile_study_tag: false,
                    use_profile_macro_study_tag: false,
                    tags: "",
                    cities_id: null,
                    universities_id: null,
                    faculty_tag: null,
                    course_tag: null,
                    is_internal: false,
                    filter_definitions_id: 21256,
                    countries: [],
                    cities: [],
                    study_tags: [
                        {
                            id: 56,
                            tag: "design",
                            name_it: "Design",
                            name_en: "Design",
                            name_es: "Diseño",
                            name_fr: "Design",
                            macro_study_tags_id: 4,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                    ],
                    macro_study_tags: [
                        {
                            id: 9,
                            tag: "architecture",
                            name_it: "Architettura",
                            name_fr: "Architecture",
                            name_en: "Architecture",
                            name_es: "Arquitectura",
                            created_at: "2020-04-29T11:11:30.000Z",
                            updated_at: "2020-04-29T11:11:30.000Z",
                        },
                    ],
                    institutes: [],
                },
                {
                    title: "Humanities & Psychology",
                    id: 482556,
                    countries_id: null,
                    countries_ids: [],
                    cities_ids: [],
                    industries_ids: [],
                    sectors_ids: [],
                    institutes_ids: [],
                    faculty_tags: ["psychology", "literature"],
                    macro_study_tags_ids: [6, 4],
                    study_tags_ids: [],
                    course_tags: [],
                    locations_ids: [],
                    use_profile_locations_id: null,
                    use_profile_institutes_id: false,
                    use_profile_cities_id: false,
                    use_profile_countries_id: false,
                    use_profile_study_tag: false,
                    use_profile_macro_study_tag: false,
                    tags: "",
                    cities_id: null,
                    universities_id: null,
                    faculty_tag: null,
                    course_tag: null,
                    is_internal: false,
                    filter_definitions_id: 21254,
                    countries: [],
                    cities: [],
                    study_tags: [],
                    macro_study_tags: [
                        {
                            id: 4,
                            tag: "literature",
                            name_it: "Lettere",
                            name_fr: "Lettres",
                            name_en: "Literature",
                            name_es: "Literatura",
                            created_at: "2020-04-29T11:11:29.000Z",
                            updated_at: "2020-04-29T11:11:29.000Z",
                        },
                        {
                            id: 6,
                            tag: "psychology",
                            name_it: "Psicologia",
                            name_fr: "Psychologie",
                            name_en: "Psycology",
                            name_es: "Psicología",
                            created_at: "2020-04-29T11:11:30.000Z",
                            updated_at: "2020-04-29T11:11:30.000Z",
                        },
                    ],
                    institutes: [],
                },
                {
                    title: "Business & Finance",
                    id: 482554,
                    countries_id: null,
                    countries_ids: [],
                    cities_ids: [],
                    industries_ids: [],
                    sectors_ids: [],
                    institutes_ids: [],
                    faculty_tags: [],
                    macro_study_tags_ids: [],
                    study_tags_ids: [38, 265, 264, 6, 263, 261, 2, 257],
                    course_tags: [
                        "finance",
                        "business_economics",
                        "economics_science",
                        "law_economics",
                        "environment_economics",
                        "economics_international",
                        "management_economics",
                        "tourism_economics",
                    ],
                    locations_ids: [],
                    use_profile_locations_id: null,
                    use_profile_institutes_id: false,
                    use_profile_cities_id: false,
                    use_profile_countries_id: false,
                    use_profile_study_tag: false,
                    use_profile_macro_study_tag: false,
                    tags: "",
                    cities_id: null,
                    universities_id: null,
                    faculty_tag: null,
                    course_tag: null,
                    is_internal: false,
                    filter_definitions_id: 21253,
                    countries: [],
                    cities: [],
                    study_tags: [
                        {
                            id: 2,
                            tag: "management_economics",
                            name_it: "Economia e Management",
                            name_en: "Managerial Economics",
                            name_es: "Administración y Dirección de Empresas",
                            name_fr: "Economie et Gestion",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 6,
                            tag: "law_economics",
                            name_it: "Economia e Diritto",
                            name_en: "Economics and Law",
                            name_es: "ADE y Derecho",
                            name_fr: "Economie et Droit",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 38,
                            tag: "finance",
                            name_it: "Finanza",
                            name_en: "Finance",
                            name_es: "Finanzas",
                            name_fr: "Finance",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 257,
                            tag: "tourism_economics",
                            name_it: "Economia e Turismo",
                            name_en: "Tourism Economics",
                            name_es: "Gestión Turística y Hotelera",
                            name_fr: "Economie et Tourisme",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 261,
                            tag: "economics_international",
                            name_it: "Economia Internazionale",
                            name_en: "International Economics",
                            name_es: "Negocios Internacionales",
                            name_fr: "Economie Internationale",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 263,
                            tag: "environment_economics",
                            name_it: "Economia Ambientale",
                            name_en: "Environmental Economics",
                            name_es: "Economía y Medio ambiente",
                            name_fr: "Economie - Géographie",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 264,
                            tag: "economics_science",
                            name_it: "Scienze Economiche",
                            name_en: "Economic Sciences",
                            name_es: "Ciencias económicas ",
                            name_fr: "Sciences économiques",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                        {
                            id: 265,
                            tag: "business_economics",
                            name_it: "Business Administration",
                            name_en: "Business Administration",
                            name_es: "Business Administration",
                            name_fr: "Administration Economique et Sociale",
                            macro_study_tags_id: 3,
                            created_at: "2020-05-11T05:54:29.000Z",
                            updated_at: "2020-05-11T05:54:29.000Z",
                        },
                    ],
                    macro_study_tags: [],
                    institutes: [],
                },
                {
                    title: "Law & Political Science",
                    id: 482560,
                    countries_id: null,
                    countries_ids: [],
                    cities_ids: [],
                    industries_ids: [],
                    sectors_ids: [],
                    institutes_ids: [],
                    faculty_tags: ["political_science", "law"],
                    macro_study_tags_ids: [7, 8],
                    study_tags_ids: [],
                    course_tags: [],
                    locations_ids: [],
                    use_profile_locations_id: null,
                    use_profile_institutes_id: false,
                    use_profile_cities_id: false,
                    use_profile_countries_id: false,
                    use_profile_study_tag: false,
                    use_profile_macro_study_tag: false,
                    tags: "",
                    cities_id: null,
                    universities_id: null,
                    faculty_tag: null,
                    course_tag: null,
                    is_internal: false,
                    filter_definitions_id: 21255,
                    countries: [],
                    cities: [],
                    study_tags: [],
                    macro_study_tags: [
                        {
                            id: 7,
                            tag: "political_science",
                            name_it: "Scienze Politiche",
                            name_fr: "Science Politique",
                            name_en: "Political Science",
                            name_es: "Ciencias Políticas",
                            created_at: "2020-04-29T11:11:30.000Z",
                            updated_at: "2020-04-29T11:11:30.000Z",
                        },
                        {
                            id: 8,
                            tag: "law",
                            name_it: "Giurisprudenza",
                            name_fr: "Droit",
                            name_en: "Law",
                            name_es: "Derecho",
                            created_at: "2020-04-29T11:11:30.000Z",
                            updated_at: "2020-04-29T11:11:30.000Z",
                        },
                    ],
                    institutes: [],
                },
            ]);
        }
    };
    /////
    AppService.prototype.getJobStatus = function (interval) {
        var _this = this;
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/common/job-offers-status";
        return timer(0, interval).pipe(mergeMap(function () { return __awaiter(_this, void 0, void 0, function () {
            var a;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get(url).toPromise()];
                    case 1:
                        a = _a.sent();
                        return [2 /*return*/, {
                                exceeded: a.active >= (a.max_active_job_offers || a.max_total_job_offers),
                                current: a.active,
                                max: (a.max_active_job_offers || a.max_total_job_offers)
                            }];
                }
            });
        }); }));
    };
    AppService.prototype.dataloopImpersonate = function (email) {
        return this.http.put("" + environment.baseUrlWs + environment.wsVerison + "employer/dataloop/impersonate", {
            operators_email: email
        });
    };
    AppService.prototype.createJBoxToken = function (jobOfferId) {
        return this.http.get("" + environment.baseUrlWs + environment.wsVerison + "employer/jobs/" + jobOfferId + "/create-jbox-token");
    };
    AppService.prototype.createJBoxTokenV2 = function (jobOfferId) {
        return this.http.get("" + environment.baseUrlWs + "v2/" + "employer/jobs/" + jobOfferId + "/create-jbox-token");
    };
    AppService.ngInjectableDef = i0.defineInjectable({ factory: function AppService_Factory() { return new AppService(i0.inject(i1.HttpClient)); }, token: AppService, providedIn: "root" });
    return AppService;
}());
export { AppService };
